import { getEnvVar } from '@studio/environment';

//Webpack  exposes a global variable called __webpack_public_path__  that allows you to set publicUrl during runtime.
//Refer https://webpack.js.org/guides/public-path/

/* eslint-disable import/first */
if (!!getEnvVar('REACT_APP_PUBLIC_URL')) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = getEnvVar('REACT_APP_PUBLIC_URL');
}
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider, ReactReduxContext } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { AppErrorBoundary } from '@shoflo/polymer';
import App from './App';
import { getUserFromSession } from 'actions/User';

import { createConfiguredStore } from './store';

import * as serviceWorker from './serviceWorker';

import '@shoflo/polymer/dist/styles/custom-fonts.css';
import './bootstrap-combined.scss';
import './index.css';
import { logEventLoopLag, initRUM } from '@studio/logger';
import packageJSON from '../package.json';

const { version, name: appName } = packageJSON;

const { store, history } = createConfiguredStore();

logEventLoopLag();
initRUM(appName, version, ['error', 'warn', 'log'], true, 30, true);

const reduxDevModeCheckFrequency =
  process.env.NODE_ENV === 'development' ? 'always' : 'never';

const root = createRoot(document.getElementById('root'));
root.render(
  <AppErrorBoundary>
    <ReduxProvider
      store={store}
      context={ReactReduxContext}
      noopCheck={reduxDevModeCheckFrequency}
    >
      <ConnectedRouter history={history} context={ReactReduxContext}>
        <App />
      </ConnectedRouter>
    </ReduxProvider>
  </AppErrorBoundary>
);

const query = new URLSearchParams(window.location.search);
const broadcastType = query.get('broadcastType');

// check if the presenter is coming via AH.
if (broadcastType) {
  store.dispatch(getUserFromSession());
}

// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
